import { authAction } from "./auth/authAction";
import { baoCaoThongKeActions } from "./bao-cao-thong-ke/baoCaoThongKeActions";
import { boMonActions } from "./category/boMonActions";
import { khoiNganhActions } from "./category/khoiNganhActions";
import { hinhThucThiActions } from "./category/hinhThucThiActions";
import { heActions } from "./category/heActions";
import { congThucTinhDiemActions } from "./category/congThucTinhDiemActions";
import { congThucTinhDiemSubActions } from "./category/congThucTinhDiemSubActions";
import { diemKyHieuActions } from "./category/diemKyHieuActions";
import { diemQuyDoiActions } from "./category/diemQuyDoiAction";
import { doanhNghiepThucTapActions } from "./category/doanhNghiepThucTapActions";
import { hocKyDangKyActions } from "./category/hocKyDangKyActions";
import { loaiChungChiActions } from "./category/loaiChungChiActions";
import { loaiChungChiChungNhanActions } from "./category/loaiChungChiChungNhanActions";
import { loaiBangTotNghiepActions } from "./category/loaiBangTotNghiepActions";
import { lopActions } from "./category/LopActions";
import { MonHocActions } from "./category/monHocActions";
import { quocTichActions } from "./category/quocTichActions";
import { quyCheActions } from "./category/quyCheActions";
import { thamSoHeThongActions } from "./category/thamSoHeThongActions";
import { thamSoHeThongChucNangActions } from "./category/thamSoHeThongChucNangActions";
import { thanhPhanMonActions } from "./category/thanhPhanMonActions";
import { thanhPhanThiActions } from "./category/ThanhPhanThiActions";
import { tieuDeBaoCaoActions } from "./category/tieuDeBaoCaoActions";
import { trangThaiHocActions } from "./category/trangThaiHocActions";
import { xepHangTotNghiepActions } from "./category/xepHangTotNghiepActions";
import { xepLoaiChungChiActions } from "./category/xepLoaiChungChiActions";
import { xepLoaiHocTapActions } from "./category/xepLoaiHocTapActions";
import { chungChiChungNhanActions } from "./chung-chi-chung-nhan/chungChiChungNhanActions";
import { chungChiChungNhanSinhVienActions } from "./chung-chi-chung-nhan/chungChiChungNhanSinhVienActions";
import { chuanDauRaChungChiActions } from "./chuong-trinh-dao-tao/chuanDauRaChungChiActions";
import { loaiChungChiDanhSachMonActions } from "./chuong-trinh-dao-tao/loaiChungChiDanhSachMonActions";
import { chuongTrinhDaoTaoActions } from "./chuong-trinh-dao-tao/chuongTrinhDaoTaoActions";
import { chuongTrinhDaoTaoChiTietActions } from "./chuong-trinh-dao-tao/chuongTrinhDaoTaoChiTietActions";
import { chuongTrinhDaoTaoKienThucActions } from "./chuong-trinh-dao-tao/chuongTrinhDaoTaoKienThucActions";
import { layoutActions } from "./common/layoutActions";
import { toolbarLopActions } from "./common/toolbarLopActions";
import { dashboardActions } from "./dashboard/dashboardActions";
import { hocLaiThiLaiActions } from "./hoc-lai-thi-lai/hocLaiThiLaiActions";
import { inBangDiemActions } from "./in-bang-diem/inBangDiemActions";
import { bieuMauNguoiDungActions } from "./quan-ly-bieu-mau/quanLyBieuMauActions";
import { danhSachDangKyNganh2Actions } from "./quan-ly-nganh-2/danhSachDangKyNganh2Actions";
import { dotDangKyNganh2Actions } from "./quan-ly-nganh-2/dotDangKyNganh2Actions";
import { tinhTrangNoMonActions } from "./tinh-trang-no-mon/tinhTrangNoMonActions";
import { dotThiActions } from "./to-chuc-thi/dotThiActions";
import { tongHopKyActions } from "./tong-hop-diem/tongHopKyActions";
import { tongHopNamActions } from "./tong-hop-diem/tongHopNamActions";
import { tongHopToanKhoaActions } from "./tong-hop-diem/tongHopToanKhoaActions";
import { tienDoNhapDiemLopHanhChinhActions } from "./tong-hop/tienDoNhapDiemLopHanhChinhActions";
import { tienDoNhapDiemLopTinChiActions } from "./tong-hop/tienDoNhapDiemLopTinChiActions";
import { traCuuDiemActions } from "./tra-cuu-diem/traCuuDiemActions";
import { chungChiSinhVienActions } from "./xet-chung-chi/chungChiSinhVienActions";
import { dotXetChungChiActions } from "./xet-chung-chi/dotXetChungChiActions";
import { dotXetChungChiPhamViActions } from "./xet-chung-chi/dotXetChungChiPhamViActions";
import { dotXetChungChiThamSoXetActions } from "./xet-chung-chi/dotXetChungChiThamSoXetActions";
import { thietLapChuanDauRaActions } from "./xet-chung-chi/thietLapChuanDauRaActions";
import { dotXetHocVuActions } from "./xet-hoc-vu/dotXetHocVuActions";
import { dotXetHocVuPhamViActions } from "./xet-hoc-vu/dotXetHocVuPhamViActions";
import { xetHocVuActions } from "./xet-hoc-vu/xetHocVuActions";
import { xetKhoaLuanActions } from "./xet-khoa-luan/xetKhoaLuanActions";
import { danhSachDuDieuKienThucTapActions } from "./xet-thuc-tap/danhSachDuDieuKienThucTapActions";
import { danhSachKhongDuDieuKienThucTapActions } from "./xet-thuc-tap/danhSachKhongDuDieuKienThucTapActions";
import { keHoachThucTapActions } from "./xet-thuc-tap/keHoachThucTapActions";
import { keHoachThucTapDoanhNghiepActions } from "./xet-thuc-tap/keHoachThucTapDoanhNghiepActions";
import { keHoachThucTapPhamViActions } from "./xet-thuc-tap/keHoachThucTapPhamViActions";
import { keHoachThucTapPhamViSinhVienActions } from "./xet-thuc-tap/keHoachThucTapPhamViSinhVienActions";
import { sinhVienDangKyThucTapActions } from "./xet-thuc-tap/sinhVienDangKyThucTapActions";
import { xetThucTapActions } from "./xet-thuc-tap/xetThucTapActions";
import { danhSachNoTotNghiepActions } from "./xet-tot-nghiep/danhSachNoTotNghiepActions";
import { danhSachTotNghiepActions } from "./xet-tot-nghiep/danhSachTotNghiepActions";
import { danhSachHoanTotNghiepActions } from "./xet-tot-nghiep/danhSachHoanTotNghiepActions";
import { duDieuKienKetQuaHocTapXetTotNghiepActions } from "./xet-tot-nghiep/duDieuKienKetQuaHocTapXetTotNghiepActions";
import { khongDuDieuKienKetQuaHocTapXetTotNghiepActions } from "./xet-tot-nghiep/khongDuDieuKienKetQuaHocTapXetTotNghiepActions";
import { xetTotNghiepActions } from "./xet-tot-nghiep/xetTotNghiepActions";
import { xetTotNghiepLanXetActions } from "./xet-tot-nghiep/xetTotNghiepLanXetActions";
import { xetTotNghiepPhamViSinhVienActions } from "./xet-tot-nghiep/xetTotNghiepPhamViSinhVienActions";
import { hocPhanMienActions } from "./hoc-phan-mien/hocPhanMienActions";
import { dotXetChungChiPhamViSinhVienActions } from "./xet-chung-chi/dotXetChungChiPhamViSinhVienActions";
import { danhSachNganh2Actions } from "./quan-ly-nganh-2/danhSachNganh2Actions";
import { dotXetHocVuPhamViSinhVienActions } from "./xet-hoc-vu/dotXetHocVuPhamViSinhVienActions";
import { quyetDinhHocVuActions } from "./xet-hoc-vu/quyetDinhHocVuActions";

export const rootActions = {
 auth: authAction,
  common: {
    layout: layoutActions,
    toolbarLop: toolbarLopActions,
  },
  category: {
    monHoc: MonHocActions,
    thanhPhanMon: thanhPhanMonActions,
    thanhPhanThi: thanhPhanThiActions,
    congThucTinhDiem: congThucTinhDiemActions,
    congThucTinhDiemSub: congThucTinhDiemSubActions,
    quyChe: quyCheActions,
    diemQuyDoi: diemQuyDoiActions,
    xepLoaiHocTap: xepLoaiHocTapActions,
    xepHangTotNghiep: xepHangTotNghiepActions,
    xepLoaiChungChi: xepLoaiChungChiActions,
    loaiChungChi: loaiChungChiActions,
    tieuDeBaoCao: tieuDeBaoCaoActions,
    lop: lopActions,
    trangThaiHoc: trangThaiHocActions,
    hocKyDangKy: hocKyDangKyActions,
    thamSoHeThongChucNang: thamSoHeThongChucNangActions,
    doanhNghiepThucTap: doanhNghiepThucTapActions,
    thamSoHeThong: thamSoHeThongActions,
    diemKyHieu: diemKyHieuActions,
    loaiChungChiChungNhan: loaiChungChiChungNhanActions,
    loaiBangTotNghiep: loaiBangTotNghiepActions,
    quocTich: quocTichActions,
    boMon: boMonActions,
    khoiNganh: khoiNganhActions,
    hinhThucThi: hinhThucThiActions,
    he: heActions,
  },
  inBangDiem: inBangDiemActions,
  tongHopDiem: {
    tongHopKy: tongHopKyActions,
    tongHopNam: tongHopNamActions,
    tongHopToanKhoa: tongHopToanKhoaActions,
  },
  xetHocVu: {
    dotXetHocVu: dotXetHocVuActions,
    dotXetHocVuPhamVi: dotXetHocVuPhamViActions,
    dotXetHocVuPhamViSinhVien: dotXetHocVuPhamViSinhVienActions,
    xetHocVu: xetHocVuActions,
    quyetDinhHocVu: quyetDinhHocVuActions,
  },
  tongHop: {
    tienDoNhapDiemLopHanhChinh: tienDoNhapDiemLopHanhChinhActions,
    tienDoNhapDiemLopTinChi: tienDoNhapDiemLopTinChiActions,
    baoCaoThongKe: baoCaoThongKeActions,
  },
  xetTotNghiep: {
    xetTotNghiepLanXet: xetTotNghiepLanXetActions,
    xetTotNghiepPhamViSinhVien: xetTotNghiepPhamViSinhVienActions,
    xetTotNghiep: xetTotNghiepActions,
    danhSachTotNghiep: danhSachTotNghiepActions,
    danhSachNoTotNghiep: danhSachNoTotNghiepActions,
    danhSachHoanTotNghiep: danhSachHoanTotNghiepActions,
    duDieuKienKetQuaHocTapXetTotNghiep: duDieuKienKetQuaHocTapXetTotNghiepActions,
    khongDuDieuKienKetQuaHocTapXetTotNghiep: khongDuDieuKienKetQuaHocTapXetTotNghiepActions,
  },
  xetChungChi: {
    dotXetChungChi: dotXetChungChiActions,
    dotXetChungChiThamSoXet: dotXetChungChiThamSoXetActions,
    dotXetChungChiPhamVi: dotXetChungChiPhamViActions,
    chungChiSinhVien: chungChiSinhVienActions,
    thietLapChuanDauRa: thietLapChuanDauRaActions,
    dotXetChungChiPhamViSinhVien: dotXetChungChiPhamViSinhVienActions,
  },
  xetThucTap: {
    keHoachThucTap: keHoachThucTapActions,
    keHoachThucTapPhamVi: keHoachThucTapPhamViActions,
    keHoachThucTapPhamViSinhVien: keHoachThucTapPhamViSinhVienActions,
    xetThucTap: xetThucTapActions,
    danhSachDuDieuKienThucTap: danhSachDuDieuKienThucTapActions,
    danhSachKhongDuDieuKienThucTap: danhSachKhongDuDieuKienThucTapActions,
    keHoachThucTapDoanhNghiep: keHoachThucTapDoanhNghiepActions,
    sinhVienDangKyThucTap: sinhVienDangKyThucTapActions,
  },
  chuongTrinhDaoTaoWrapper: {
    chuongTrinhDaoTao: chuongTrinhDaoTaoActions,
    chiTiet: chuongTrinhDaoTaoChiTietActions,
    chuongTrinhDaoTaoKienThuc: chuongTrinhDaoTaoKienThucActions,
    chuanDauRaChungChi: chuanDauRaChungChiActions,
    loaiChungChiDanhSachMon: loaiChungChiDanhSachMonActions,
  },
  chungChiChungNhan: {
    chungChiChungNhan: chungChiChungNhanActions,
    chungChiChungNhanSinhVien: chungChiChungNhanSinhVienActions,
  },
  bieuMauNguoiDung: bieuMauNguoiDungActions,
  traCuuDiem: traCuuDiemActions,
  quanLyNganh2: {
    dotDangKyNganh2: dotDangKyNganh2Actions,
    danhSachDangKyNganh2: danhSachDangKyNganh2Actions,
    danhSachNganh2: danhSachNganh2Actions,
  },
  dashboard: dashboardActions,
  xetKhoaLuan: xetKhoaLuanActions,
  toChucThi: {
    dotThi: dotThiActions,
  },
  hocLaiThiLai: hocLaiThiLaiActions,
  tinhTrangNoMon: tinhTrangNoMonActions,
  hocPhanMien: hocPhanMienActions,
}